<ng-template #groupViewTemplate let-obj="obj" let-list="list">
  <input
    type="text"
    class="object-row__input"
    #groupNameModel="ngModel"
    [(ngModel)]="obj.groupName"
    [disabled]="isGroupNameEditDisabled(obj)"
    [class.object-row__input--invalid]="isDraftGroupNameMissing(obj) && groupNameModel.touched"
    (ngModelChange)="onInputChangeDebounced(obj, list, obj.memberType)"
    [placeholder]="obj.memberType === 'group' ? 'Group Name' : 'Object Value'"
  />
  <div class="object-row__required-hint" *ngIf="isDraftGroupNameMissing(obj)">
    Required
  </div>
  <div class="object-row__meta">
    <span class="object-row__tag" [ngClass]="{'object-row__tag--group' : obj.memberType === 'group'}">
      {{ obj.memberType != '' ? obj.memberType : 'UNKNOWN' }}
    </span>
    <span class="action-tag action-tag--add" *ngIf="getMemberAction(obj) === 'add'">
      Add
    </span>
    <span class="action-tag action-tag--remove" *ngIf="getMemberAction(obj) === 'remove'">
      Remove
    </span>
  </div>
</ng-template>

<ng-template #inputTemplate let-obj="obj" let-list="list">
  <input
    type="text"
    class="object-row__input"
    #memberInput
    #memberModel="ngModel"
    [(ngModel)]="obj.memberName"
    [disabled]="isMemberEditDisabled(obj)"
    [class.object-row__input--invalid]="isInputError(obj) && (memberModel.touched || memberModel.dirty) && (obj.memberName?.trim())"
    [class.object-row__input--warning]="isInputWarning(obj) && (memberModel.touched || memberModel.dirty) && (obj.memberName?.trim())"
    (ngModelChange)="onInputChangeDebounced(obj, list, obj.memberType)"
    (focus)="setInputFocus(obj, true)"
    (blur)="setInputFocus(obj, false)"
    [attr.data-uid]="obj.uid"
    [attr.autofocus]="obj.requestFocus ? true : null"
    [placeholder]="obj.memberType === 'group' ? 'Group Name' : 'Object Value'"
  />
  <div class="object-row__error-hint" *ngIf="isInputError(obj) && (memberModel.touched || memberModel.dirty) && (obj.memberName?.trim())">
    {{ getInputIssueMessage(obj) }}
  </div>
  <div class="object-row__warning-hint" *ngIf="isInputWarning(obj) && (memberModel.touched || memberModel.dirty) && (obj.memberName?.trim())">
    {{ getInputIssueMessage(obj) }}
  </div>
  
  <div class="object-row__meta">
    <span class="object-row__tag" [ngClass]="{'object-row__tag--group' : obj.memberType === 'group', 'object-row__tag--unknown': (obj.memberName?.trim()) && (!obj.memberType || obj.memberType === 'unknown')}">
      {{ obj.memberType != '' ? obj.memberType : 'UNKNOWN' }}
    </span>
    <span class="action-tag action-tag--add" *ngIf="getMemberAction(obj) === 'add'">
      Add
    </span>
    <span class="action-tag action-tag--remove" *ngIf="getMemberAction(obj) === 'remove'">
      Remove
    </span>
    <button 
      *ngIf="getMemberAction(obj) !== 'remove' && obj.memberName?.trim()" 
      type="button" 
      class="remove-btn"
      (click)="removeMember(obj)"
      title="Mark for removal">
      ✕
    </button>
    <button 
      *ngIf="getMemberAction(obj) === 'remove'" 
      type="button" 
      class="restore-btn"
      (click)="restoreMember(obj)"
      title="Undo removal">
      ↶
    </button>
  </div>
  <!-- Suggestions for group type -->
  <ng-container *ngIf="obj.memberType === 'group' && isFocused(obj)">
    <div class="suggestions" *ngIf="getGroupSuggestions(obj.memberName) as groupSuggestions">
      <button
        type="button"
        class="suggestion-chip"
        *ngFor="let s of groupSuggestions"
        (mousedown)="$event.preventDefault()"
        (click)="applyGroupSuggestion(obj, s, memberInput, list)">
        {{ s }}
      </button>
    </div>
  </ng-container>
  <!-- Suggestions for object values -->
  <ng-container *ngIf="obj.memberType !== 'group' && isFocused(obj)">
    <div class="suggestions" *ngIf="getObjectSuggestions(obj.memberName) as objectSuggestions">
      <button
        type="button"
        class="suggestion-chip"
        *ngFor="let s of objectSuggestions"
        (mousedown)="$event.preventDefault()"
        (click)="applyObjectSuggestion(obj, s, memberInput, list)">
        {{ s }}
      </button>
    </div>
  </ng-container>
</ng-template>


<div class="view-page">
  <section class="view-panel">
    <section class="selector-section">
      <div class="selector-region">
        <div class="selector-card">

          <div class="custom-dropdown" [class.open]="dropdownOpen">
            <button type="button" class="dropdown-trigger" (click)="toggleDropdown()" aria-haspopup="listbox"
              [attr.aria-expanded]="dropdownOpen">
              <ng-container *ngIf="selectedInventory; else placeholder">
                <div class="selected-summary">
                  <div class="summary-primary">{{ selectedInventory.hostname }} <div
                      *ngIf="selectedInventory.masterConfig === 1" class="gold-badge" aria-label="Gold Source">Gold
                      Source</div>
                  </div>
                  <div class="summary-secondary">{{ selectedInventory.hpnaGroup }} <span>Last Modified: {{
                      formatLastModified(selectedInventory.lastModified) }}</span></div>
                </div>
              </ng-container>
              <ng-template #placeholder>
                <span class="placeholder">Choose a device…</span>
              </ng-template>
              <span class="chevron" aria-hidden="true">▾</span>
            </button>

            <div class="dropdown-panel" *ngIf="dropdownOpen">
              <div class="dropdown-panel__list">
                <button type="button" class="dropdown-option" *ngFor="let item of filteredInventory"
                  (click)="selectItem(item)">
                  <span class="option-primary">{{ item.hostname }} <span *ngIf="item.masterConfig === 1" class="gold-badge inline" aria-label="Gold Source">Gold Source</span></span>
                  <span class="option-secondary">{{ item.hpnaGroup }} Last Modified: {{ formatLastModified(item.lastModified) }}</span>
                </button>
                <div class="no-results" *ngIf="filteredInventory.length === 0">
                  No devices found matching "{{ deviceSearchTerm }}"
                </div>
              </div>
            </div>
          </div>
          <div class="button-group" *ngIf="selectedInventory">
            <button type="button" class="primary-button" (click)="openInventoryDialog()">
              Device Overview
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="view-content">
      <section class="details-region" *ngIf="selectedInventory" [class.collapsed]="isCollapsed">
        <div class="tree-stack">
          <section class="tree-card">
            <form class="tree-search" (submit)="$event.preventDefault(); search();">
              <label class="sr-only" for="searchInput">Search configured objects</label>
              <input id="searchInput" name="treeSearch" class="tree-search__input" type="text"
                placeholder="Type to filter configured objects" [(ngModel)]="searchTerm"
                (ngModelChange)="liveSearch()" />
            </form>

            <div class="tree-results" [class.loading]="loadingTree">
              <div class="tree-empty" *ngIf="loadingTree">Loading results…</div>
              <div class="tree-empty" *ngIf="!loadingTree && !(searchResults && searchResults.length)">
                No results found. Try a different search term.
              </div>
              <div class="tree-scroll" *ngIf="!loadingTree && searchResults && searchResults.length">
                <!-- Start create new group at root -->
                <div class="simple-result-item">
                  <div class="result-header">
                    <ng-container *ngIf="!(selectedEditNode && selectedEditNode.isRootDraft === true); else cancelNewRoot">
                      <button
                        type="button"
                        class="add-btn"
                        (click)="createNewRootGroup()">
                        + Create New Group
                      </button>
                    </ng-container>
                    <ng-template #cancelNewRoot>
                      <button
                        type="button"
                        class="add-btn"
                        (click)="unselectEditNode()">
                        Cancel
                      </button>
                      <button
                        type="button"
                        class="add-btn success"
                        [disabled]="hasBlockingEditErrors || isDraftGroupNameMissing(selectedEditNode)"
                        (click)="confirmCreateNewRootGroup()">
                        Create
                      </button>
                    </ng-template>
                  </div>
                  <div *ngIf="selectedEditNode && selectedEditNode.isRootDraft === true">
                    <div class="object-row">
                      <div class="object-row__main object-row__main-outline object-row__main-outline--success">
                        <span class="group-name object-row">
                          <ng-container *ngTemplateOutlet="groupViewTemplate; context: { obj: selectedEditNode, list: null}"></ng-container>
                        </span>
                        <div style="padding: 5px 0 0 0;">
                          <div class="object-row__info" *ngFor="let member of selectedEditNode.memberGroups">
                            <ng-container *ngTemplateOutlet="inputTemplate; context: { obj: member, list: selectedEditNode.memberGroups }"></ng-container>
                          </div>
                        </div>
                        <div style="padding: 5px 0 0 0;">
                          <div class="object-row__info" *ngFor="let member of selectedEditNode.memberObjects">
                            <ng-container *ngTemplateOutlet="inputTemplate; context: { obj: member, list: selectedEditNode.memberObjects }"></ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- End create new group at root -->
                <div class="simple-result-item" *ngFor="let obj of searchResults" [attr.id]="'group-' + obj.groupName">
                  <div class="result-header" (click)="!isEditingGroup(obj) && toggleNode(obj)">
                    <button
                      type="button"
                      class="expand-btn"
                      *ngIf="isEditingGroup(obj) || (obj.members && obj.members.length > 0) || hasPendingChanges(obj.groupName)"
                      [attr.aria-label]="isExpanded(obj) ? 'Collapse' : 'Expand'"
                      (click)="$event.stopPropagation(); toggleNode(obj)"
                      (mousedown)="$event.preventDefault(); $event.stopPropagation()">
                      <span>{{ isExpanded(obj) ? '−' : '+' }}</span>
                    </button>
                    <span class="group-name" *ngIf="!isEditingGroup(obj)" [innerHTML]="highlight(obj.groupName)"></span>
                    <button type="button" class="add-btn" (click)="$event.stopPropagation();
                      showAsms(obj)" *ngIf="obj.asms.length > 0">
                      View ASMS
                    </button>
                    <span class="group-name object-row" *ngIf="isEditingGroup(obj)" >
                      <ng-container *ngTemplateOutlet="groupViewTemplate; context: { obj: selectedEditNode, list: null }"></ng-container>
                    </span>
                    <button
                      type="button"
                      class="add-btn"
                      *ngIf="!isEditingGroup(obj)"
                      (click)="$event.stopPropagation(); selectEditNode(obj)">
                      Edit Group
                    </button>
                    <button
                      type="button"
                      class="add-btn delete-btn"
                      *ngIf="!isEditingGroup(obj)"
                      (click)="$event.stopPropagation(); deleteGroup(obj)"
                      title="Delete this group and all members">
                      Delete Group
                    </button>
                    <button
                      type="button"
                      class="add-btn"
                      *ngIf="isEditingGroup(obj)"
                      (click)="$event.stopPropagation(); unselectEditNode()">
                      Close Edit
                    </button>
                  </div>
                  <div class="result-members" *ngIf="isExpanded(obj) && !isEditingGroup(obj)">
                    <div class="member-row" *ngFor="let member of getDisplayedMembers(obj)">
                      <div class="member-info">
                        <span class="member-type" *ngIf="member.memberType">{{ member.memberType }}</span>
                        <span class="member-name" [innerHTML]="highlight(member.memberName)"></span>
                      </div>
                      <button type="button" class="jump-btn" *ngIf="member.memberType?.toLowerCase() === 'group'"
                        (click)="$event.stopPropagation(); jumpToGroup(member.memberName, obj.groupName)">
                        Jump to
                      </button>
                    </div>
                    <div class="member-row" *ngFor="let pending of getPendingAddedMembers(obj.groupName, obj.originalMembers || obj.members)">
                      <div class="member-info">
                        <span class="member-type" *ngIf="pending.memberType">{{ pending.memberType }}</span>
                        <span class="member-name" [innerHTML]="highlight(pending.memberName)"></span>
                      </div>
                      <button type="button" class="jump-btn" *ngIf="pending.memberType.toLowerCase() === 'group'"
                        (click)="$event.stopPropagation(); jumpToGroup(pending.memberName, obj.groupName)">
                        Jump to
                      </button>
                    </div>
                    <div class="member-row" *ngIf="!(obj.members && obj.members.length)">
                      <div class="member-info">
                        <span class="member-name" *ngIf="getPendingAddedMembers(obj.groupName, obj.originalMembers || obj.members).length === 0">No members loaded for this group. Use Edit Group or View Changes to review staged changes.</span>
                      </div>
                    </div>
                    <button type="button" class="show-more-btn" *ngIf="hasMoreMembers(obj)"
                      (click)="$event.stopPropagation(); toggleShowAllMembers(obj.groupName)">
                      {{ isShowingAllMembers(obj.groupName) ? 'Show Less' : 'Show All Members' }}
                    </button>
                  </div>
                  <!-- Will insert edit functionality here -->
                  <div *ngIf="isEditingGroup(obj) && isExpanded(obj)">
                    <div class="object-row">
                      <div class="object-row__main object-row__main-outline">
                        <div style="padding: 5px 0 0 0;">
                          <div class="object-row__info" *ngFor="let member of selectedEditNode.memberGroups">
                            <ng-container *ngTemplateOutlet="inputTemplate; context: { obj: member, list: selectedEditNode.memberGroups }"></ng-container>
                          </div>
                        </div>
                        <div style="padding: 5px 0 0 0;">
                          <div class="object-row__info" *ngFor="let member of selectedEditNode.memberObjects">
                            <ng-container *ngTemplateOutlet="inputTemplate; context: { obj: member, list: selectedEditNode.memberObjects }"></ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Will end edit functionality here -->
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      <aside class="changes-summary-column" *ngIf="selectedInventory">
        <h3>View Changes</h3>
        <!-- Change Control Selection - Always Visible -->
        <div class="change-control-selector">
          <p class="selector-description">
            Select an existing change request or create a new one.
          </p>
          <div *ngIf="changeSelectionError" class="error-message">
            {{ changeSelectionError }}
          </div>
          <div class="selector-control">
            <select class="change-select" [(ngModel)]="currentCrNumber" (ngModelChange)="onChangeSelected($event)" id="changeRequestSelect">
              <option value="" disabled>Select a change...</option>
              <option value="CREATE_NEW">+ Create New CR</option>
              <option *ngFor="let change of activeChanges" [value]="change.crNumber">
                {{ change.crNumber }}
              </option>
            </select>
            <input
              *ngIf="showNewCrInput"
              class="change-input"
              [class.error]="isCrNumberDuplicate || !!newCrNumberError"
              type="text"
              [(ngModel)]="newCrNumber"
              placeholder="Enter new Change ID"
              autofocus />
            <div *ngIf="showNewCrInput && isCrNumberDuplicate" class="error-message">
              CR already exists
            </div>
            <div *ngIf="showNewCrInput && !isCrNumberDuplicate && isUserMissingForNewChange" class="error-message">
              User information is missing. Please sign in again or reload the page.
            </div>
            <div *ngIf="showNewCrInput && !isCrNumberDuplicate && newCrNumberError" class="error-message">
              {{ newCrNumberError }}
            </div>
          </div>
          <button 
            type="button" 
            class="primary-button"
            [disabled]="!currentCrNumber || currentCrNumber === 'CREATE_NEW'"
            (click)="jumpToChange(currentCrNumber)"
            title="Open change request in new tab">
            Jump to Change →
          </button>
          <!-- <div class="selected-cr-display" *ngIf="selectedCrNumber">
            <strong>Selected CR:</strong> {{ selectedCrNumber }}
          </div> -->
        </div>

        <div class="view-changes-loading" *ngIf="viewChangesLoading" aria-label="Loading changes">
          <div class="view-changes-spinner"></div>
        </div>

        <ng-container *ngIf="!viewChangesLoading">
        <p class="changes-summary-empty" *ngIf="isEditFlowBlocked">
          Select an existing change request above, or choose “+ Create New CR” and enter a new Change ID to start editing.
        </p>

        <p class="changes-summary-empty" *ngIf="!isEditFlowBlocked && (!pendingChanges || pendingChanges.length === 0)">
          No pending changes yet. Use the tree on the left to add or edit objects and groups.
        </p>

        <div class="edit-summary" *ngIf="pendingChanges && pendingChanges.length">
          <ng-container *ngFor="let groupChanges of allFilteredChanges">
            <div class="group-changes-section" *ngIf="groupChanges.groupName && groupChanges.changes.length > 0">
              <h4 (click)="navigateToGroup(groupChanges.groupName)" class="clickable-group-header">
                {{ groupChanges.groupName }}
              </h4>
              <ul class="changes-summary-list">
                <li *ngFor="let change of groupChanges.changes">
                  <div class="change-item-wrapper">
                    <div class="change-content">
                      <div class="change-line">{{ change.summary }}</div>
                      <div class="change-meta" *ngIf="change.meta">{{ change.meta }}</div>
                    </div>
                    <button 
                      type="button" 
                      class="change-remove-btn"
                      (click)="removeChangeFromSummary(groupChanges.groupName, change)"
                      title="Remove this change">
                      ✕
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </ng-container>
          <div class="save-actions">
            <button 
              type="button" 
              class="primary-button" 
              [disabled]="isSaveDisabled"
              (click)="saveTreeEditsToChange()">
              <span *ngIf="!isSavingChanges">Save Tree Edits to Change</span>
              <span *ngIf="isSavingChanges">Saving...</span>
            </button>
            <div class="save-status" *ngIf="treeEditsSaved && !isSavingChanges">Saved</div>
          </div>
        </div>

        </ng-container>
      </aside>

      <section class="empty-state" *ngIf="!selectedInventory">
        <h2>Select a device to get started</h2>
        <p>Use the selector to load interface, DNS, and configuration tree information.</p>
      </section>
    </div>

    <footer class="collapsed-footer" *ngIf="selectedInventory && isCollapsed">
      <span>Details collapsed. Expand to review configuration data.</span>
      <button type="button" class="ghost-button" (click)="toggleCollapse()">Expand Details</button>
    </footer>
  </section>
</div>

<div *ngIf="inventoryDialogOpen" class="inventory-modal-backdrop" (click)="closeInventoryDialog()">
  <div class="inventory-modal" (click)="$event.stopPropagation()">
    <button class="inventory-modal-close" (click)="closeInventoryDialog()">&times;</button>
    <h3>Device Overview</h3>

     <!-- <button
      type="button"
      class="primary-button"
      (click)="setGoldSource()"
      [disabled]="!selectedInventory || selectedInventory.masterConfig === 1 || isSettingGoldSource">
      <span *ngIf="!isSettingGoldSource">Set Gold Source</span>
      <span *ngIf="isSettingGoldSource">Setting...</span>
    </button>  -->

    <button type="button" class="link-button" style="margin-bottom: 12px;" (click)="showMoreInfo = !showMoreInfo">
      {{ showMoreInfo ? 'Hide extra fields' : 'Show extra fields' }}
    </button>

    <section class="overview-section">
      <h4>Device Details</h4>
      <dl class="info-card__grid">
        <div>
          <dt>Hostname</dt>
          <dd>{{ selectedInventory?.hostname }}</dd>
        </div>
        <div>
          <dt>Group</dt>
          <dd>{{ selectedInventory?.hpnaGroup }}</dd>
        </div>
        <!-- <div>
          <dt>Software</dt>
          <dd>{{ selectedInventory?.asaVersion ? getTruncatedVersion(selectedInventory.asaVersion).substring(1) : '—' }}</dd>
        </div> -->
        <div>
          <dt>Last Modified</dt>
          <dd>{{ selectedInventory?.lastModified ? formatLastModified(selectedInventory.lastModified) : '—' }}</dd>
        </div>
        <div>
          <dt>Retrieved</dt>
          <dd>{{ selectedInventory?.retrievedDate ? formatLastModified(selectedInventory.retrievedDate) : '—' }}</dd>
        </div>
      </dl>

      <dl class="info-card__grid secondary" *ngIf="showMoreInfo">
        <div>
          <dt>ASA Version</dt>
          <dd>{{ selectedInventory?.asaVersion || '—' }}</dd>
        </div>
        <div>
          <dt>Hardware Model</dt>
          <dd>{{ selectedInventory?.hardwareModel || '—' }}</dd>
        </div>
        <div>
          <dt>Serial</dt>
          <dd>{{ selectedInventory?.serialNumber || '—' }}</dd>
        </div>
        <div>
          <dt>ASA Role</dt>
          <dd>{{ selectedInventory?.asaRole || '—' }}</dd>
        </div>
        <div>
          <dt>Mgmt IP</dt>
          <dd>{{ selectedInventory?.mgmtIpAddress || '—' }}</dd>
        </div>
      </dl>
    </section>

    <section class="overview-section" *ngIf="selectedInterface && selectedInterface.length">
      <header class="section-header">
        <h4>Interface Summary</h4>
        <span class="info-count">{{ selectedInterface.length }} interfaces</span>
      </header>
      <div class="interface-list">
        <div class="interface-row" *ngFor="let interface of selectedInterface">
          <div>
            <span class="label">Name</span>
            <span class="value">{{ interface.interfaceName }}</span>
          </div>
          <div>
            <span class="label">IP</span>
            <span class="value">{{ interface.interfaceIP || '—' }}</span>
          </div>
          <div>
            <span class="label">Subnet</span>
            <span class="value">{{ interface.interfaceSubnet || '—' }}</span>
          </div>
        </div>
      </div>
    </section>

    <section class="overview-section" *ngIf="selectedDns && selectedDns.length">
      <h4>DNS Servers</h4>
      <ul class="dns-list">
        <li *ngFor="let dns of selectedDns">{{ dns.dnsServer }}</li>
      </ul>
    </section>
  </div>
</div>

<div *ngIf="selectedAsms" class="asms-modal-backdrop" (click)="closeAsmsModal()">
  <div class="asms-modal" (click)="$event.stopPropagation()" tabindex="0">
    <button class="asms-modal-close" (click)="closeAsmsModal()" aria-label="Close ASMS">&times;</button>

    <div class="asms-modal-header">
      <h4>ASMS</h4>
      <div class="asms-modal-subtitle">
        <span *ngIf="selectedAsms?.groupName as groupName">{{ groupName }}</span>
        <span *ngIf="!selectedAsms?.groupName">ASMS details</span>
        <span class="asms-modal-count" *ngIf="selectedAsmsEntries.length">• {{ selectedAsmsEntries.length }} record(s)</span>
      </div>
    </div>

    <div class="asms-modal-body">
      <div class="asms-empty" *ngIf="!selectedAsmsEntries.length">
        No ASMS details available.
      </div>

      <div class="asms-records" *ngIf="selectedAsmsEntries.length">
        <section class="asms-record" *ngFor="let entry of selectedAsmsEntries; trackBy: trackByAsmsEntry">
          <div class="asms-record-title">
            <span class="asms-record-id">ASMS {{ getAsmsId(entry) }}</span>
            <span class="asms-record-app" *ngIf="getAsmsAppName(entry) as app">— {{ app }}</span>
          </div>

          <dl class="asms-kv">
            <div class="asms-kv-row" *ngFor="let item of getAsmsKeyValues(entry)">
              <dt>{{ item.label }}</dt>
              <dd>{{ item.value }}</dd>
            </div>
          </dl>

          <details class="asms-description" *ngIf="getAsmsDescription(entry) as desc">
            <summary>Description</summary>
            <div class="asms-description-text">{{ desc }}</div>
          </details>
        </section>
      </div>

      <details class="asms-raw">
        <summary>Raw JSON</summary>
        <pre>{{ selectedAsms | json }}</pre>
      </details>
    </div>
  </div>
</div>